var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {fill:none;stroke:#050505;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#050505;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.9,
    cy: 4,
    r: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10.2,
    cy: 6.7,
    r: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 21,
    cy: 6.8,
    r: 1.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2.8,
    cy: 17.6,
    r: 1.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.2,
    cy: 19.9,
    r: 1.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.8,
    cy: 11.2,
    r: 2.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.2,
    cy: 3.6,
    r: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.1,
    cy: 12.2,
    r: 3.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.6,
    cy: 19.3,
    r: 3.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterial);
export default __webpack_public_path__ + "static/media/icon-material.adfe287d3821d8287db96f37ad420197.svg";
export { ForwardRef as ReactComponent };